import { BellOutlined } from '@ant-design/icons';
import { Badge, Button, Modal } from 'antd';
import { useEffect } from 'react';
import useRequiredActionsStore from 'store/requiredActionsStore';

export default function RequiredActionsIcon() {
  const requiredActions = useRequiredActionsStore(s => s.requiredActions);
  const setModalOpen = useRequiredActionsStore(s => s.setModalOpen);

  return requiredActions.length > 0 && (
    <Badge count={requiredActions.length} size="small">
      <BellOutlined className="text-white text-lg" onClick={() => setModalOpen(true)} />
    </Badge>
  )
}
